type Tenant = {
  hideVersion?: boolean
  hideAdminNavLinks?: boolean
  hideRialticOnlyViews: boolean
  singleTenantWorkspaceId: string
}

export default defineAppConfig({
  tenant: {
    hideVersion: false,
    hideAdminNavLinks: false,
    hideRialticOnlyViews: false,
    singleTenantWorkspaceId: '',
  } as Tenant,
  host: '',
  version: '',
})
